/* eslint-disable */
export const messages = {
  AD: "Andorra",
  AE: "Vereinigte Arabische Emirate",
  AF: "Afghanistan",
  AG: "Antigua und Barbuda",
  AI: "Anguilla",
  AL: "Albanien",
  AM: "Armenien",
  AO: "Angola",
  AQ: "Antarktis",
  AR: "Argentinien",
  AS: "Samoa-Amerikanisch (US-Verwaltung)",
  AT: "Österreich",
  AU: "Australien",
  AW: "Aruba",
  AX: "Aland",
  AZ: "Aserbeidschan",
  BA: "Bosnien und Herzegowina",
  BB: "Barbados",
  BD: "Bangladesch",
  BE: "Belgien",
  BF: "Burkina Faso",
  BG: "Bulgarien",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy (Franz.Verwaltung)",
  BM: "Bermuda",
  BN: "Brunei Darussalam",
  BO: "Bolivien",
  BQ: "Bonaire, St. Eustatius und Saba",
  BR: "Brasilien",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvetinsel",
  BW: "Botsuana",
  BY: "Belarus (Weissrussland)",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Kokosinseln (Keeling)",
  CD: "Demokratische Republik",
  CF: "Zentralafrikanische Republik",
  CG: "Kongo",
  CH: "Schweiz",
  CI: "Cote D'Ivoire (Elfenbeinkueste)",
  CK: "Verwaltung",
  CL: "Chile",
  CM: "Kamerun",
  CN: "China",
  CO: "Kolumbien",
  CR: "Costa Rica",
  CU: "Kuba",
  CV: "Kap Verde",
  CW: "Curaçao",
  CX: "Weihnachtsinsel (Austr.Verwaltung)",
  CY: "Zypern",
  CZ: "Tschechien",
  DE: "Deutschland",
  DJ: "Dschibuti",
  DK: "Dänemark",
  DM: "Dominica",
  DO: "Dominikanische Republik",
  DZ: "Algerien",
  EC: "Ecuador",
  EE: "Estland",
  EG: "Ägypten",
  EH: "Westsahara Eigenst.Staat",
  ER: "Eritrea",
  ES: "Spanien",
  ET: "Äthiopien",
  FI: "Finnland",
  FJ: "Fidschi",
  FK: "Falklandinseln (Malvinen)",
  FM: "Mikronesien",
  FO: "Faeroeer Inseln Dän.Verwaltung",
  FR: "Frankreich",
  GA: "Gabun",
  GB: "Großbritannien",
  GD: "Grenada",
  GE: "Georgien",
  GF: "Französisch Guayana",
  GG: "Guernsey Insel",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Grönland (Dän.Verwaltung)",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe (Franz.Verwaltung)",
  GQ: "Äquatorial Guinea",
  GR: "Griechenland",
  GS: "Südgeorgien und Süd-Sandwich-Insel",
  GT: "Guatemala",
  GU: "Guam (US-Verwaltung)",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hongkong",
  HM: "Heard und Mc Donald Inseln (unter Austr.Verw.)",
  HN: "Honduras",
  HR: "Kroatien",
  HT: "Haiti",
  HU: "Ungarn",
  ID: "Indonesien",
  IE: "Irland",
  IL: "Israel",
  IM: "Man, Insel",
  IN: "Indien",
  IO: "Brit.Terr.Im Indischen Ozean",
  IQ: "Irak",
  IR: "Iran",
  IS: "Island",
  IT: "Italien",
  JE: "Jersey Insel",
  JM: "Jamaika",
  JO: "Jordanien",
  JP: "Japan",
  KE: "Kenia",
  KG: "Kirgisistan",
  KH: "Kambodscha",
  KI: "Kiribati",
  KM: "Komoren",
  KN: "St.Kitts und Nevis",
  KP: "Korea, Demokratische Volksrepublik",
  KR: "Korea, Republik",
  KW: "Kuwait",
  KY: "Kaimaninseln",
  KZ: "Kasachstan",
  LA: "Laos",
  LB: "Libanon",
  LC: "St.Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberien",
  LS: "Lesotho",
  LT: "Litauen",
  LU: "Luxemburg",
  LV: "Lettland",
  LY: "Libysch-Arabische Dschamahirija",
  MA: "Marokko",
  MC: "Monaco",
  MD: "Moldau, Republik",
  ME: "Montenegro",
  MF: "Saint Martin (Franz. Verwaltung)",
  MG: "Madagaskar",
  MH: "Marshall Inseln",
  MK: "Republik Nordmazedonien",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolei",
  MO: "Macao",
  MP: "Marianen, Nördliche",
  MQ: "Martinique Franz.Verwaltung",
  MR: "Mauretanien",
  MS: "Montserrat (GB-Verwaltung)",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Malediven",
  MW: "Malawi",
  MX: "Mexiko",
  MY: "Malaysia",
  MZ: "Mosambik",
  NA: "Namibia",
  NC: "Neukaledonien",
  NE: "Niger",
  NF: "Norfolkinsel",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Niederlande",
  NO: "Norwegen",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Neuseeland",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Französisch-Polynesien",
  PG: "Papua-Neuguinea",
  PH: "Philippinen",
  PK: "Pakistan",
  PL: "Polen",
  PM: "Saint Pierre und Miquelon (Franz.Verwaltung)",
  PN: "Pitcairn-Inseln",
  PR: "Puerto Rico (US-Verwaltung)",
  PS: "Palästina",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Katar",
  RE: "Réunion (Franz.Verwaltung)",
  RO: "Rumänien",
  RS: "Serbien",
  RU: "Russische Föderation",
  RW: "Ruanda",
  SA: "Saudi-Arabien",
  SB: "Salomonen",
  SC: "Seychellen",
  SD: "Sudan",
  SE: "Schweden",
  SG: "Singapur",
  SH: "St. Helena Ascension Tristan da Cunha",
  SI: "Slowenien",
  SJ: "Svalbard und Jan Mayen",
  SK: "Slowakei",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "Südsudan",
  ST: "São Tomé und Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten (Niederländ.Verwaltung)",
  SY: "Syrien",
  SZ: "Eswatini",
  TC: "Turks- und Caicosinseln",
  TD: "Tschad",
  TF: "Französische Südgebiete",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tadschikistan",
  TK: "Tokelau",
  TL: "Osttimor",
  TM: "Turkmenistan",
  TN: "Tunesien",
  TO: "Tonga",
  TR: "Türkei",
  TT: "Trinidad und Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tansania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "USA - Sonstige Kleine Inseln",
  US: "Vereinigte Staaten",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VA: "Vatikanstadt",
  VC: "St.Vincent und Grenadinen",
  VE: "Venezuela",
  VG: "Britische Jungferninseln",
  VI: "Amerikanische Jungferninseln",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis und Futuna",
  WS: "Samoa",
  YE: "Jemen",
  YT: "Mayotte (Franz.Verwaltung)",
  ZA: "Südafrika",
  ZM: "Sambia",
  ZW: "Simbabwe",
};
